import { NgModule } from '@angular/core';
import { TranslatePipe } from './translate.pipe';
import { AuthImagePipe } from './auth-image.pipe';
import { PercentSuffixPipe } from './percent-suffix.pipe';

@NgModule({
    declarations: [
        TranslatePipe,
        AuthImagePipe,
        PercentSuffixPipe
    ],
    imports     : [
    ],
    exports     : [   
        TranslatePipe,
        AuthImagePipe,
        PercentSuffixPipe
    ]
})
export class PipesModule 
{
}
